/* Shipping Store */

import {
  fetchSalesOrders,
  createShippingQuotes,
  purchaseLabelByRateId,
  printLabelByZPL
} from '@/api'

const state = {
  orders: [],
  quotes: []
}

const actions = {
  fetchSalesOrders (context, params) {
    return fetchSalesOrders(params).then(response => {
      context.commit('setOrders', response.data)
    })
  },
  createShippingQuotes (context, payload) {
    return createShippingQuotes(payload).then(r => {
      context.commit('setShippingQuotes', r.data['shipEngineResponse'])
    })
  },
  purchaseLabelByRateId (context, rateId) {
    return purchaseLabelByRateId(rateId)
  },
  printLabelByZPL (context, payload) {
    return printLabelByZPL(payload)
  },
  resetQuotes (context) {
    context.commit('setShippingQuotes', [])
  }
}

const mutations = {
  setOrders (state, payload) {
    state.orders = payload
  },
  setShippingQuotes (state, payload) {
    state.quotes = payload
  }
}

const getters = {
  getOrders (state) {
    return state.orders
  },
  getShippingQuotes (state) {
    return state.quotes
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
